import { Component, OnInit, OnDestroy, ViewChild, ElementRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { AdminService } from '../../admin.service';
import { BlockService } from '../../../services/block.service';
import { ElementService } from '../../../services/element.service';
import { Block } from '../../../models/block.model';
import { Element } from '../../../models/element.model';
import { Subscription } from 'rxjs/Subscription';

import * as moment from 'moment';
import { FormGroup, FormControl } from '@angular/forms';
import { GroupService } from '../../../services/group.service';

declare var jQuery: any;
declare const $: any;
declare var swal: any;
@Component({
  selector: 'app-elements',
  templateUrl: './elements.component.html',
  styleUrls: ['./elements.component.css'],
})
export class ElementsComponent implements OnInit, OnDestroy {
  loading = false;

  blocksSubscription: Subscription;
  blockSubscription: Subscription;

  elementDeleteSubscription: Subscription;

  groupsSubscription: Subscription;
  group_id = 0;

  dataTableHtml: any;

  selectGroupForm: FormGroup;

  @ViewChild('previewModal') previewModal: ElementRef;

  categories = {
    'enewsletter': {
      id: 1,
      name: 'eMarketing'
    },
    'buyer-match': {
      id: 2,
      name: 'Buyer Match'
    },
    'quick-enquiry': {
      id: 3,
      name: 'Quick Enquiry'
    },
    'brochure': {
      id: 4,
      name: 'Brochure'
    },
    'property-guide': {
      id: 5,
      name: 'Property Guide'
    },
    'social-media': {
      id: 6,
      name: 'Social Media'
    },
    'email-signature': {
      id: 7,
      name: 'Email Signature'
    },
    'dl-card': {
      id: 8,
      name: 'DL Card'
    },
    'sign-board': {
      id: 9,
      name: 'Signboard'
    }
  };

  elements: Element[];

  blocks = [];
  groups = [];
  category: string;
  category_id: number;
  category_name = '';
  block_id = 0;

  constructor(private adminService: AdminService,
              private blockService: BlockService,
              private elementService: ElementService,
              private groupService: GroupService,
              private route: ActivatedRoute,
              private router: Router,
              private ngZone: NgZone ) {
                const $this = this;

                window['onEdit'] = function(id) {
                  $this.onEdit(id);
                };

                window['onHtml'] = function(id) {
                  $this.onHtml(id);
                };

                window['onDuplicate'] = function(id) {
                  $this.onDuplicate(id);
                };

                window['onPreview'] = function(id) {
                  $this.onPreview(id);
                };

                window['onDelete'] = function(id) {
                  $this.onDelete(id);
                };
               }

  ngOnInit() {
    this.groupService.httpGetGroups();

    this.route.params.subscribe(
      (params: Params) => {
        this.category = params['type'];

        if ( this.categories[this.category].id !== this.blockService.category_id ) {
          this.blockService.block_id = 0;
        }

        this.category_id = this.blockService.category_id = this.categories[this.category].id;
        this.category_name = this.categories[this.category].name;

        if ( this.blockService.group_id !== 0 ) {
          this.loading = true;
          this.blockService.httpGetBlocks(
            {
              category_id: this.category_id
            }
          );
        }
      }
    );

    this.groupsSubscription = this.groupService.groupsChanged.subscribe(
      (groups: any) => {
        this.groups = [];
        if ( groups.length > 0 ) {
          this.groups = groups;
        }
      }
    );

    this.blocksSubscription = this.blockService.blocksChanged.subscribe(
      (blocks: Block[]) => {
        this.blocks = [];
        this.blocks = blocks;
        if ( blocks.length > 0 ) {
          if ( this.blockService.block_id !== 0 ) {
            this.blockService.httpGetBlock(this.blockService.block_id, {
              select: 'dashboard'
            });
            this.loading = true;
          } else {
            this.blockService.block_id = this.block_id = +this.blocks[0].ID;
            if ($.fn.DataTable.isDataTable(this.dataTableHtml)) {
              this.dataTableHtml.destroy();
            }
            this.initDT();
          }
        }
      }
    );

    this.blockSubscription = this.blockService.blockChanged.subscribe(
      (block: Block) => {
        if ( typeof block.ID !== 'undefined' ) {
          this.elements = block.elements;
          this.blockService.block_id = this.block_id = block.ID;

          if ($.fn.DataTable.isDataTable(this.dataTableHtml)) {
            this.dataTableHtml.destroy();
          }
          this.initDT();
        }
      }
    );

    this.elementDeleteSubscription = this.elementService.elementDelete.subscribe(
      (element: any) => {
        if ( typeof element !== 'undefined' && element.status === 'success' ) {
          swal(
            'Deleted!',
            'Client has been deleted.',
            'success'
          );

          if ($.fn.DataTable.isDataTable(this.dataTableHtml)) {
            this.dataTableHtml.destroy();
          }
          this.initDT();
        }
      }
    );

    this.initSelectGroupForm();
  }

  initSelectGroupForm() {
    this.selectGroupForm = new FormGroup({
      'group_id': new FormControl('')
    });

    if ( this.blockService.group_id !== 0 ) {
      this.selectGroupForm.patchValue({
        'group_id': this.blockService.group_id
      });
    }
  }

  initDT() {
    setTimeout(() => {
      const $this = this;
      this.dataTableHtml = $('.datatable-elements-' + this.category).DataTable({
      'processing': true,
      'serverSide': true,
      'stateSave': true,
      'ajax': {
        'url': $this.adminService.appConfig.API_ENDPOINT + '/elements/datatable',
        'type': 'GET',
        'data': function ( d ) {
          d.block_id = $this.blockService.block_id;
          d.group_id = $this.blockService.group_id;
        },
        'beforeSend': function (request) {
          request.setRequestHeader('Authorization', 'Bearer ' + $this.adminService.authService.auth.__token);
          request.setRequestHeader('MD-Authorization', $this.adminService.authService.auth.token);
        },
        'dataSrc': function (json) {
          $this.loading = false;
          return json.data;
        }
      },
      'pageLength': 50,
      'columns' : [
        { 'data': 'ID' },
        { 'data': function(row) {
          return row['provider'].toUpperCase();
        } },
        { 'data': function(row) {
          return row['title'];
        } },
        { 'data': function(row) {
          return row['group'].title;
        } },
        { 'data': function(row) {
          if ( row['media_attribute'] ) {
            return String(row['media_attribute'].slug).toUpperCase();
          }

          return '';
        } },
        { 'data': function(row) {
          return ( row['department'] !== null ? row['department'].title : '');
        } },
        { 'data': function(row) {
          if ( row['client_id'] === 0 ) {
            return 'All';
          }

          return row['client'].name;
        } },
        { 'data': function(row) {
          return moment(row['created']).format('YYYY-MM-DD');
        } },
        { 'data': function(row) {
          return moment(row['modified']).format('YYYY-MM-DD');
        } },
        { 'data': function(row) {
          return '<span class="label label-success">' + (row['is_active'] === 1 ? 'Active' : 'Inactive') + '</span>';
        } },
        { 'data': function(row) {
          let html = '';

          // tslint:disable-next-line:max-line-length
          html += '<button onclick="onEdit(' + row['ID'] + ')" class="btn-table" title="Edit"><i class="icon feather icon-edit"></i></button>';
          html += '<a href="/admin/templates/elements/' + $this.category + '/' + row['ID'] + '/edit" target="_blank" class="btn-table" title="Edit New Tab"><i class="icon feather icon-external-link"></i></a>';
          // tslint:disable-next-line:max-line-length
          // html += '<button onclick="onHtml(' + row['ID'] + ')" type="button" class="btn-table" title="HTML"><i class="icon feather icon-file-text"></i></button>';
          // tslint:disable-next-line:max-line-length
          html += '<button onclick="onDuplicate(' + row['ID'] + ')" type="button" class="btn-table" title="Duplicate"><i class="icon feather icon-copy"></i></button>';
          html += '<button onclick="onPreview(' + row['ID'] + ')" data-target="#previewElement" data-toggle="modal" type="button" class="btn-table" title="Preview"><i class="icon feather icon-eye"></i></button>';
          // tslint:disable-next-line:max-line-length
          html += '<button onclick="onDelete(' + row['ID'] + ')" type="button" class="btn-table" title="Delete"><i class="icon feather icon-trash"></i></button>';
          return html;
        } },
      ],
      'columnDefs': [ {
          'targets': [ 0 ],
          'visible': false,
          'searchable': false,
        }, {
          'targets': [ 1 ],
          'name': 'provider',
          'searchable': true
        }, {
          'targets': [ 2 ],
          'name': 'title',
          'searchable': true
        }, {
          'targets': [ 3 ],
          'name': 'group',
          'searchable': true,
          'className': 'cut-text'
        }, {
          'targets': [ 4 ],
          'name': 'media_attribute',
          'searchable': true
        }, {
          'targets': [ 5 ],
          'name': 'department',
          'searchable': true,
          'className': 'cut-text'
        }, {
          'targets': [ 6 ],
          'name': 'client',
          'searchable': true,
          'className': 'cut-text'
        }
      ],
      'order': []
      });
    }, 500);
  }

  filterClick() {
    return false;
  }

  newBlockElement() {
    this.router.navigate(['new', this.blockService.block_id], {relativeTo: this.route});
  }

  setBlockID(id: number) {
    this.blockService.block_id = id;
    this.blockService.httpGetBlock(this.blockService.block_id, {
      select: 'dashboard'
    });
    this.loading = true;
  }

  onPreview($id: number) {
    this.previewModal.nativeElement.querySelector('.modal-body img').src
      = this.adminService.appConfig.S3_URL + 'elements/generated-thumbnails/' + $id + '.jpg';
  }

  onDelete(id: number) {
    const $this = this;

    swal({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result) {
        $this.loading = true;
        $this.elementService.httpDeleteElement(id);
      }
    }).catch(swal.noop);
  }

  onEdit(id: number) {
    this.ngZone.run(() => {
      this.router.navigate([ 'admin', 'templates', 'elements', this.category , id, 'edit']);
    });
    return;
  }

  onHtml(id: number) {
    this.ngZone.run(() => {
      this.router.navigate([ 'admin', 'templates', 'elements', this.category , id, 'html']);
    });
    return;
  }

  onDuplicate(id: number) {
    this.ngZone.run(() => {
      this.router.navigate([ 'admin', 'templates', 'elements', this.category , id, 'edit', 'duplicate']);
    });
    return;
  }

  onChangeGroup(id) {
    this.blockService.group_id = id;

    this.loading = true;
    this.blockService.httpGetBlocks(
      {
        category_id: this.category_id
      }
    );
  }

  ngOnDestroy() {
    this.adminService.authService.cancelRequest();
    this.elementDeleteSubscription.unsubscribe();
    this.blocksSubscription.unsubscribe();
    this.blockSubscription.unsubscribe();
    if ($.fn.DataTable.isDataTable(this.dataTableHtml)) {
      this.dataTableHtml.destroy();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/templates/elements/elements.component.ts